var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#fff","strokeWidth":"140","fill":"none"},[React.createElement("circle",{"cx":"470","cy":"470","r":"470","stroke":"none","key":0}),React.createElement("circle",{"cx":"470","cy":"470","r":"400","key":1})]));
}

Circle.defaultProps = {"width":"940","height":"940"};

module.exports = Circle;

Circle.default = Circle;
